module.exports = __webpack_public_path__ + "static/Ill_BG-f4e2c11dc977e12d744a059bcef7e8ca.png";